import { Component, EventEmitter, Input, Output } from '@angular/core';

export type MonacoEditorLanguage = 'html' | 'css' | 'javascript';

if (typeof window !== 'undefined' && !(window as unknown as { MonacoEnvironment?: unknown }).MonacoEnvironment) {
  (window as unknown as { MonacoEnvironment: unknown }).MonacoEnvironment = {
    baseUrl: `${window.location.origin}/assets/monaco`,
    getWorkerUrl: (): string => `${window.location.origin}/assets/monaco/vs/base/worker/workerMain.js`,
  };
}

@Component({
  selector: 'pdq-monaco-editor',
  templateUrl: './monaco-editor.component.html',
  styleUrls: ['./monaco-editor.component.scss'],
  standalone: false,
})
export class MonacoEditorComponent {
  @Input()
  set language(value: MonacoEditorLanguage) {
    this._language = value;
    this.editorOptions = { ...this.editorOptions, language: value };
  }
  get language(): MonacoEditorLanguage {
    return this._language;
  }

  @Input() value = '';

  @Output() valueChange = new EventEmitter<string>();

  editorOptions = {
    theme: 'vs-dark',
    language: 'html',
    automaticLayout: true,
    minimap: { enabled: false },
    wordWrap: 'on',
    tabSize: 2,
    scrollBeyondLastLine: false,
  };

  private _language: MonacoEditorLanguage = 'html';

  onModelChange(next: string): void {
    this.value = next;
    this.valueChange.emit(next);
  }
}
